// extracted by mini-css-extract-plugin
export var messageSideLeft = "_t3-1";
export var stateContainer = "_t3-0";